module.exports = __webpack_public_path__ + "od-earn-points/od-earn-points-0daab17b61f9ac855885a1455faf821f.svg";